import { SurveyQuery } from '@surveycake/logic-engine';
import { PageType } from 'app/core/page';

type Utm =
  | 'utm_source'
  | 'utm_medium'
  | 'utm_term'
  | 'utm_content'
  | 'utm_campaign';

interface AmplitudeEventData extends Pick<SurveyQuery, Utm> {
  pageNavi?: PageType;
  svid?: string;
}

export function createAmplitudeEventData(
  surveyHash: string,
  query?: SurveyQuery,
  page?: PageType
) {
  const data: AmplitudeEventData = {
    utm_source: query && query.utm_source ? query.utm_source : 'unknow',
    utm_medium: query && query.utm_medium ? query.utm_medium : 'unknow',
    utm_term: query && query.utm_term ? query.utm_term : 'unknow',
    utm_content: query && query.utm_content ? query.utm_content : 'unknow',
    utm_campaign: query && query.utm_campaign ? query.utm_campaign : 'unknow'
  };

  if (page) {
    data.pageNavi = page;
  }

  if (surveyHash) {
    data.svid = surveyHash;
  }

  return data;
}
